export enum URLSearchParamKey {
    ACCESS_CODE = 'access-code',
}
